export default __webpack_public_path__ + "static/ore jul 20-271d792bb96b974361a081fa25cfa71f.wav";